/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as a from "react";
import e from "prop-types";
import { Popup as q } from "@progress/kendo-react-popup";
import { cloneDate as f } from "@progress/kendo-date-math";
import { classNames as v, Keys as d, validatePackage as _, canUseDOM as w, AsyncFocusBlur as K, kendoThemeMaps as b, createPropsContext as U, withIdHOC as j, withPropsContext as H } from "@progress/kendo-react-common";
import { clockIcon as $ } from "@progress/kendo-svg-icons";
import { provideLocalizationService as W, registerForLocalization as G } from "@progress/kendo-react-intl";
import { packageMetadata as X } from "../package-metadata.mjs";
import { toggleClock as m, messages as u, timePickerCancel as Z, timePickerSet as S, toggleTimeSelector as y } from "../messages/index.mjs";
import { DateInput as J } from "../dateinput/DateInput.mjs";
import { TimeSelector as Q } from "./TimeSelector.mjs";
import { MAX_TIME as Y, MIN_TIME as ee, setTime as I, MIDNIGHT_DATE as te } from "../utils.mjs";
import { isInRange as ie, isBiggerThanMax as se, isSmallerThanMin as oe } from "./utils.mjs";
import { PickerFloatingLabel as ne } from "../hooks/usePickerFloatingLabel.mjs";
import { Button as ae } from "@progress/kendo-react-buttons";
import { MOBILE_MEDIUM_DEVISE as re } from "../common/constants.mjs";
import { AdaptiveMode as le } from "../common/AdaptiveMode.mjs";
import { ActionSheetContent as he } from "@progress/kendo-react-layout";
const n = class n extends a.Component {
  constructor(i) {
    super(i), this._element = null, this._dateInput = a.createRef(), this._timeSelector = null, this.shouldFocusDateInput = !1, this.prevShow = !1, this.focus = () => {
      this.dateInput && this.dateInput.focus();
    }, this.renderTimeSelector = () => {
      const { smoothScroll: t, cancelButton: s, nowButton: o, disabled: r, format: h, steps: l } = this.props;
      return /* @__PURE__ */ a.createElement(
        Q,
        {
          ref: this.setTimeSelectorRef,
          className: this.mobileMode ? "k-reset k-timeselector-lg" : "",
          mobileMode: this.mobileMode,
          show: this.show,
          cancelButton: s,
          disabled: r,
          nowButton: o,
          format: h,
          min: this.min,
          max: this.max,
          steps: l,
          smoothScroll: t,
          value: this.value,
          footer: !this.mobileMode,
          handleTimeChange: this.mobileMode && this.handleTimeChange,
          onChange: this.handleValueChange,
          onReject: this.handleValueReject
        }
      );
    }, this.renderPopup = () => {
      const { popupClass: t, ...s } = this.popupSettings, o = v(
        t
      ), r = {
        popupClass: "k-timepicker-popup k-list-container",
        show: this.show,
        animate: this.element !== null,
        anchor: this.element,
        className: o,
        id: this._popupId,
        anchorAlign: {
          horizontal: "left",
          vertical: "bottom"
        },
        popupAlign: {
          horizontal: "left",
          vertical: "top"
        },
        ...s
      };
      return this.props.popup ? /* @__PURE__ */ a.createElement(this.props.popup, { ...r }, this.renderTimeSelector()) : /* @__PURE__ */ a.createElement(q, { ...r }, this.renderTimeSelector());
    }, this.renderAdaptivePopup = () => {
      const { windowWidth: t = 0 } = this.state, s = {
        expand: this.show,
        onClose: this.handleBlur,
        adaptiveTitle: this.props.adaptiveTitle,
        windowWidth: t,
        footer: {
          cancelText: this.localizationService.toLanguageString(m, u[Z]),
          onCancel: this.handleValueReject,
          applyText: this.localizationService.toLanguageString(S, u[S]),
          onApply: (o) => this.handleValueChange(o)
        }
      };
      return /* @__PURE__ */ a.createElement(le, { ...s }, /* @__PURE__ */ a.createElement(he, { className: "!k-overflow-hidden" }, this.renderTimeSelector()));
    }, this.setTimeSelectorRef = (t) => {
      this._timeSelector = t;
    }, this.nextValue = (t, s) => t.value !== void 0 ? t.value : s.value, this.nextShow = (t, s) => t.show !== void 0 ? t.show : s.show, this.handleInputValueChange = (t) => {
      const s = this.mergeTime(t.value);
      this.handleValueChange({ ...t, value: s });
    }, this.handleTimeChange = (t) => {
      this.setState({ candidate: t.time });
    }, this.handleValueChange = (t) => {
      this.setState({
        value: f(t.value || this.state.candidate)
      }), this.valueDuringOnChange = t.value, this.showDuringOnChange = !1, this.shouldFocusDateInput = !0;
      const { onChange: s } = this.props, o = this.state.candidate || this.value;
      s && s.call(void 0, {
        syntheticEvent: t.syntheticEvent,
        nativeEvent: t.nativeEvent,
        value: o,
        show: this.show,
        target: this
      }), this.valueDuringOnChange = void 0, this.showDuringOnChange = void 0, this.setShow(!1);
    }, this.handleFocus = () => {
      this.setState({ focused: !0 });
    }, this.handleBlur = () => {
      this.setState({ focused: !1 }), this.setShow(!1);
    }, this.handleValueReject = (t) => {
      this.setShow(!1);
    }, this.handleIconClick = (t) => {
      this.props.disabled || (this.shouldFocusDateInput = !0, this.setShow(!this.show));
    }, this.handleIconMouseDown = (t) => {
      t.preventDefault();
    }, this.handleKeyDown = (t) => {
      const { altKey: s, keyCode: o } = t;
      if (o === d.esc) {
        this.shouldFocusDateInput = !0, this.setShow(!1);
        return;
      }
      s && (o === d.up || o === d.down) && (t.preventDefault(), t.stopPropagation(), this.shouldFocusDateInput = o === d.up, this.setShow(o === d.down));
    }, _(X), this.state = {
      value: this.props.defaultValue || n.defaultProps.defaultValue,
      show: this.props.defaultShow || n.defaultProps.defaultShow,
      focused: !1,
      candidate: null
    }, this.normalizeTime = this.normalizeTime.bind(this), this.setShow = this.setShow.bind(this), this.mergeTime = this.mergeTime.bind(this);
  }
  get _popupId() {
    return this.props.id + "-popup-id";
  }
  get document() {
    if (w)
      return this.element && this.element.ownerDocument || document;
  }
  /**
   * Gets the wrapping element of the TimePicker.
   */
  get element() {
    return this._element;
  }
  /**
   * Gets the DateInput component inside the TimePicker component.
   */
  get dateInput() {
    return this._dateInput.current;
  }
  /**
   * Gets the TimeSelector component inside the TimePicker component.
   */
  get timeSelector() {
    return this._timeSelector;
  }
  /**
   * Gets the value of the TimePicker.
   */
  get value() {
    const i = this.valueDuringOnChange !== void 0 ? this.valueDuringOnChange : this.props.value !== void 0 ? this.props.value : this.state.value;
    return i !== null ? f(i) : null;
  }
  /**
   * Gets the popup state of the TimeSelector.
   */
  get show() {
    return this.showDuringOnChange !== void 0 ? this.showDuringOnChange : this.props.show !== void 0 ? this.props.show : this.state.show;
  }
  /**
   * Gets the `name` property of the TimePicker.
   */
  get name() {
    return this.props.name;
  }
  /**
   * Represents the validity state into which the TimePicker is set.
   */
  get validity() {
    const i = this.value && this.normalizeTime(this.value), t = this.normalizeTime(this.min), s = this.normalizeTime(this.max), o = ie(i, t, s), r = this.props.validationMessage !== void 0, h = (!this.required || this.value !== null) && o, l = this.props.valid !== void 0 ? this.props.valid : h;
    return {
      customError: r,
      rangeOverflow: se(i, s),
      rangeUnderflow: oe(i, t),
      valid: l,
      valueMissing: this.value === null
    };
  }
  /**
   * The mobile mode of the ComboBox.
   */
  get mobileMode() {
    return !!(this.state.windowWidth && this.state.windowWidth <= re && this.props.adaptive);
  }
  /**
   * @hidden
   */
  get validityStyles() {
    return this.props.validityStyles !== void 0 ? this.props.validityStyles : n.defaultProps.validityStyles;
  }
  /**
   * @hidden
   */
  get required() {
    return this.props.required !== void 0 ? this.props.required : n.defaultProps.required;
  }
  get popupSettings() {
    return this.props.popupSettings || n.defaultProps.popupSettings;
  }
  get min() {
    return this.props.min !== void 0 ? this.props.min : n.defaultProps.min;
  }
  get max() {
    return this.props.max !== void 0 ? this.props.max : n.defaultProps.max;
  }
  get dateInputComp() {
    return this.props.dateInput || n.defaultProps.dateInput;
  }
  get localizationService() {
    return W(this);
  }
  /**
   * @hidden
   */
  componentDidMount() {
    var i;
    this.observerResize = w && window.ResizeObserver && new window.ResizeObserver(this.calculateMedia.bind(this)), this.show && this.forceUpdate(), (i = this.document) != null && i.body && this.observerResize && this.observerResize.observe(this.document.body);
  }
  /**
   * @hidden
   */
  componentDidUpdate() {
    this._timeSelector && this.show && !this.prevShow ? this._timeSelector.focusActiveList() : this.dateInput && this.dateInput.element && !this.show && this.shouldFocusDateInput && this.dateInput.element.focus({ preventScroll: !0 }), this.prevShow = this.show, this.shouldFocusDateInput = !1;
  }
  /**
   * @hidden
   */
  componentWillUnmount() {
    var i;
    (i = this.document) != null && i.body && this.observerResize && this.observerResize.disconnect();
  }
  /**
   * @hidden
   */
  render() {
    const {
      size: i = n.defaultProps.size,
      rounded: t = n.defaultProps.rounded,
      fillMode: s = n.defaultProps.fillMode,
      disabled: o,
      tabIndex: r,
      title: h,
      id: l,
      className: M,
      format: T,
      formatPlaceholder: C,
      width: D,
      name: O,
      steps: k,
      validationMessage: P,
      required: z,
      validityStyles: x,
      ariaLabelledBy: E,
      ariaDescribedBy: R
    } = this.props, c = !this.validityStyles || this.validity.valid, B = {
      disabled: o,
      format: T,
      formatPlaceholder: C,
      id: l,
      ariaLabelledBy: E,
      ariaDescribedBy: R,
      max: this.normalizeTime(this.max),
      min: this.normalizeTime(this.min),
      name: O,
      onChange: this.handleInputValueChange,
      required: z,
      steps: k,
      tabIndex: this.show ? -1 : r,
      title: h,
      valid: this.validity.valid,
      validationMessage: P,
      validityStyles: x,
      value: this.value && this.normalizeTime(this.value),
      label: void 0,
      placeholder: this.state.focused ? null : this.props.placeholder,
      ariaHasPopup: "dialog",
      ariaExpanded: this.show,
      size: null,
      fillMode: null,
      rounded: null,
      readonly: this.mobileMode
    }, V = this.localizationService.toLanguageString(m, u[m]), F = this.localizationService.toLanguageString(y, u[y]), g = /* @__PURE__ */ a.createElement(
      K,
      {
        onFocus: this.handleFocus,
        onBlur: this.mobileMode ? void 0 : this.handleBlur,
        onSyncBlur: this.props.onBlur,
        onSyncFocus: this.props.onFocus
      },
      ({ onFocus: N, onBlur: A }) => /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
        "span",
        {
          id: this.props.id,
          ref: (L) => {
            this._element = L;
          },
          className: v(
            "k-input",
            "k-timepicker",
            {
              [`k-input-${b.sizeMap[i] || i}`]: i,
              [`k-rounded-${b.roundedMap[t] || t}`]: t,
              [`k-input-${s}`]: s,
              "k-invalid": !c,
              "k-required": this.required,
              "k-disabled": this.props.disabled
            },
            M
          ),
          onKeyDown: this.handleKeyDown,
          style: { width: D },
          onFocus: N,
          onBlur: A,
          onClick: this.mobileMode ? this.handleIconClick : void 0
        },
        /* @__PURE__ */ a.createElement(
          this.dateInputComp,
          {
            _ref: this._dateInput,
            ariaRole: "combobox",
            ariaControls: this._popupId,
            ...B
          }
        ),
        /* @__PURE__ */ a.createElement(
          ae,
          {
            tabIndex: -1,
            type: "button",
            icon: "clock",
            svgIcon: $,
            onMouseDown: this.handleIconMouseDown,
            onClick: this.mobileMode ? void 0 : this.handleIconClick,
            title: F,
            className: "k-input-button",
            rounded: null,
            fillMode: s,
            "aria-label": V
          }
        ),
        !this.mobileMode && this.renderPopup()
      ), this.mobileMode && this.renderAdaptivePopup())
    );
    return this.props.label ? /* @__PURE__ */ a.createElement(
      ne,
      {
        dateInput: this._dateInput,
        label: this.props.label,
        editorId: l,
        editorValid: c,
        editorDisabled: this.props.disabled,
        children: g,
        style: { width: this.props.width }
      }
    ) : g;
  }
  normalizeTime(i) {
    return I(te, i);
  }
  setShow(i) {
    const { onOpen: t, onClose: s } = this.props;
    this.show !== i && (this.setState({ show: i }), i && t && t.call(void 0, {
      target: this
    }), !i && s && s.call(void 0, {
      target: this
    }));
  }
  mergeTime(i) {
    return this.value && i ? I(this.value, i) : i;
  }
  calculateMedia(i) {
    for (let t of i)
      this.setState({ windowWidth: t.target.clientWidth });
  }
};
n.displayName = "TimePicker", n.propTypes = {
  className: e.string,
  cancelButton: e.bool,
  nowButton: e.bool,
  defaultShow: e.bool,
  defaultValue: e.instanceOf(Date),
  disabled: e.bool,
  format: e.oneOfType([
    e.string,
    e.shape({
      skeleton: e.string,
      pattern: e.string,
      date: e.oneOf(["short", "medium", "long", "full"]),
      time: e.oneOf(["short", "medium", "long", "full"]),
      datetime: e.oneOf(["short", "medium", "long", "full"]),
      era: e.oneOf(["narrow", "short", "long"]),
      year: e.oneOf(["numeric", "2-digit"]),
      month: e.oneOf(["numeric", "2-digit", "narrow", "short", "long"]),
      day: e.oneOf(["numeric", "2-digit"]),
      weekday: e.oneOf(["narrow", "short", "long"]),
      hour: e.oneOf(["numeric", "2-digit"]),
      hour12: e.bool,
      minute: e.oneOf(["numeric", "2-digit"]),
      second: e.oneOf(["numeric", "2-digit"]),
      timeZoneName: e.oneOf(["short", "long"])
    })
  ]),
  formatPlaceholder: e.oneOfType([
    e.oneOf(["wide", "narrow", "short", "formatPattern"]),
    e.shape({
      year: e.string,
      month: e.string,
      day: e.string,
      hour: e.string,
      minute: e.string,
      second: e.string
    })
  ]),
  id: e.string,
  ariaLabelledBy: e.string,
  ariaDescribedBy: e.string,
  min: e.instanceOf(Date),
  max: e.instanceOf(Date),
  name: e.string,
  popupSettings: e.shape({
    animate: e.bool,
    appendTo: e.any,
    popupClass: e.string
  }),
  show: e.bool,
  steps: e.shape({
    hour: e.number,
    minute: e.number,
    second: e.number
  }),
  smoothScroll: e.bool,
  tabIndex: e.number,
  title: e.string,
  value: e.instanceOf(Date),
  width: e.oneOfType([e.number, e.string]),
  validationMessage: e.string,
  required: e.bool,
  validate: e.bool,
  valid: e.bool,
  size: e.oneOf([null, "small", "medium", "large"]),
  rounded: e.oneOf([null, "small", "medium", "large", "full"]),
  fillMode: e.oneOf([null, "solid", "flat", "outline"])
}, n.defaultProps = {
  defaultShow: !1,
  defaultValue: null,
  disabled: !1,
  format: "t",
  max: Y,
  min: ee,
  popupSettings: {},
  tabIndex: 0,
  steps: {},
  required: !1,
  validityStyles: !0,
  dateInput: J,
  size: "medium",
  rounded: "medium",
  fillMode: "solid"
};
let p = n;
const de = U(), ue = j(H(de, p));
ue.displayName = "KendoReactTimePicker";
G(p);
export {
  ue as TimePicker,
  de as TimePickerPropsContext,
  p as TimePickerWithoutContext
};
